@if (user$ | async; as user) {
  @if (user?.isLoggedIn) {
    <clr-dropdown>
      @if (hasUsername) {
        <button class="nav-text" clrDropdownTrigger aria-label="open user profile">
          <div class="user-header">
            <span class="username">{{ user.username }}</span>
            @if (userRole$ | async; as role) {
              <span class="user-role">{{ role }}</span>
            }
          </div>
          <cds-icon shape="angle" direction="down"></cds-icon>
        </button>
      }
      <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
        @if (userRole$ | async; as role) {
          <div class="user-info">
            <div class="user-info-item">
              <span class="label">Rôle:</span>
              <span class="value">{{ role }}</span>
            </div>
          </div>
        }
        <button (click)="logout()" clrDropdownItem>
          <cds-icon shape="logout"></cds-icon>
          Déconnexion
        </button>
      </clr-dropdown-menu>
    </clr-dropdown>
  } @else {
    <div class="nav-text">
      <a href="javascript://" class="nav-link nav-icon" (click)="login()">
        <cds-icon shape="login"></cds-icon>
        Connexion
      </a>
    </div>
  }
}

